import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { requireRole } from "@/lib/auth/require-role";
import UsageLogsPage from "@/features/usage-logs/UsageLogsPage";

// use_case carries a CSV of call_type slugs (e.g. "embedding,vision") plus
// the synthetic "transcribe" group expanded server-side. URL-roundtripped so
// F5 / share-link preserves the chip selection.
const usageLogsSearchSchema = z.object({
  use_case: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/_admin/usage-logs")({
  validateSearch: usageLogsSearchSchema.parse,
  beforeLoad: () => requireRole("admin"),
  component: UsageLogsPage,
});
